var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9495 15.7486H2.04979C1.78184 15.7486 1.53425 15.6056 1.40028 15.3736C1.26631 15.1415 1.26631 14.8556 1.40029 14.6236L8.34979 2.62359C8.48386 2.39192 8.73124 2.24927 8.99891 2.24927C9.26658 2.24927 9.51396 2.39192 9.64804 2.62359L16.5975 14.6236C16.7314 14.8555 16.7315 15.1413 16.5977 15.3733C16.4639 15.6053 16.2166 15.7483 15.9488 15.7486H15.9495ZM9.00004 4.49859L3.35179 14.2486H14.6498L9.00004 4.49859ZM9.74629 11.2493H8.24629V7.49859H9.74629V11.2493Z",
    fill: "#FD7062"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25004 12.0001H9.75004V13.5001H8.25004V12.0001Z",
    fill: "#FD7062"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warningRed.f7277f147030579c27e7cf482f4fe25f.svg";
export { ForwardRef as ReactComponent };